(function () {
    'use strict';

    a3_pilot_reports.directive('crewInfo', crewInfo);
    /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name crewInfo
    * @restrict E
    * @description
    *   Crew Table with a double row per crew member
    * @example
    *   Usage:
    *   <crew-info></crew-info>
    * @ngInject
    */
    function crewInfo($uibModal, UserFactory, PaxInfoFactory) {
        function link(scope, element, attrs) {
            scope.user = UserFactory.getUser();
            scope.openPhoneConfirmation = openPhoneConfirmation;
            scope.showInfoRow = showInfoRow;
            scope.showArrivalFormat = showArrivalFormat;
            scope.hiddenButtonHistory = scope.aircraftroute;

            if (scope.type == "flight") {
                scope.crewMembers = scope.crew.filter(x => (x.position == 'CP' || x.position == "FO") && !x.isDHC) .sort((a, b) => {
                    const positionOrder = ['CP', 'FO' ]; 
                    return positionOrder.indexOf(a.position) - positionOrder.indexOf(b.position);
                });
            }
            else if (scope.type == "cabin") {
                scope.crewMembers = scope.crew.filter(x => (x.position == 'SA' || x.position == "FA") && !x.isDHC);
            }
            else {
                scope.crewMembers = scope.crew.filter(x => x.isDHC);
                if(scope.crewMembers.length > 0 && !scope.hiddenButtonHistory){
                    PaxInfoFactory.getPaxInfoList(scope.selectedflightid, function (passengerList) {
                        if (passengerList) {
                            scope.crewMembers.forEach(function (crewMember) {
                                var matchedPassenger = passengerList.filter(x =>
                                    (x.IsDHC && x.Fullname.toUpperCase().includes(crewMember.name.toUpperCase()))
                                );
                                if (matchedPassenger && matchedPassenger.length > 0) {
                                    crewMember.seatNo = matchedPassenger[0].SeatNo;
                                }
                            });
                        }
                    });
                }
            }

            function openPhoneConfirmation(crew) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/CrewInfo/dlgConfirmCrewCall.html',
                    controller: 'CrewCallCtrl',
                    size: 'md',
                    resolve: {
                        crew: function () { return crew; },
                        flightId: function () { return scope.selectedflightid; },
                        groundDutyId: function () { return null; }
                    }
                });
                modalInstance.result.then(function (confirm) {

                });
            }

            function showInfoRow(item) {
                var differentUser = scope.user.aimsId != item.aimsId
                var phoneAvailable = item.PhoneNumber && item.PhoneNumber != '';
                var previousDutyAvailable = item.PreviousDuty && item.PreviousDuty.isDifferent;
                var phonesAvailable = scope.crew.filter(x => x.PhoneNumber && x.PhoneNumber != '').length > 0;
                var checkInStatusAvailable = scope.crew.filter(x => x.CheckIn || x.WillBeThereAt).length > 0;

                return differentUser && (phoneAvailable || previousDutyAvailable || phonesAvailable || checkInStatusAvailable);
            }

            function showArrivalFormat(previousDuty) {
                var formatedArrival = '';
                var dateFormat = 'HH:mm';
                if (previousDuty.showArrivalDate) {
                    dateFormat = 'dd/MM HH:mm';
                }
                if (previousDuty.ATA) {
                    formatedArrival = '- A ' + moment(previousDuty.ATA).format(dateFormat);
                } else if (previousDuty.ETA) {
                    formatedArrival = '- E ' + moment(previousDuty.ETA).format(dateFormat);
                } else {
                    formatedArrival = '- S ' + moment(previousDuty.STA).format(dateFormat);
                }


                return formatedArrival;
            }

        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/CrewInfo/crewInfo.tpl.html',
            scope: { crew: "=", type: "=", flightId: "=" },
            link: link
        }
    }

})();
